// extracted by mini-css-extract-plugin
export var divider = "_ed-7";
export var itemsToggle = "_ed-8";
export var mergeModal = "_ed-1";
export var optionCard = "_ed-4";
export var radioGroup = "_ed-6";
export var radioOption = "_ed-0";
export var selected = "_ed-5";
export var shipmentOptions = "_ed-2";
export var tableOptions = "_ed-3";